import { MuiTheme, color, createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = (props?: { isOpen: boolean }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      deliverylogHeading: {
        padding: '0px 40px',
        justifyContent: 'space-between',
        background: 'transparent',
        display: 'flex',
        height: '100px',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
          padding: '16px 24px',
          height: '100px'
        },
        [theme.breakpoints.only('xs')]: {
          justifyContent: 'center',
          height: '100%'
        }
      },
      deliverylogOptions: {
        padding: '0px 40px 30px',
        background: 'transparent',
        display: 'flex',
        height: '70px',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
          padding: '16px 24px',
          height: '100px'
        },
        [theme.breakpoints.only('xs')]: {
          justifyContent: 'center',
          height: '100%'
        }
      },
      filterOptions: {
        padding: '0px 40px',
        background: 'transparent',
        display: 'flex',
        height: '50px',
        alignItems: 'center'
      },
      deliverylogText: {
        lineHeight: '1',
        fontSize: '40px',
        fontWeight: 600,
        letterSpacing: 'normal',
        [theme.breakpoints.down('sm')]: {
          fontSize: '36px'
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: '32px'
        },
        [theme.breakpoints.only('md')]: {
          fontSize: '36px'
        }
      },
      deliverylogOuterBox: {
        flex: 'none',
        background: 'transparent',
        padding: '0px 40px 0px',
        [theme.breakpoints.down('sm')]: {
          padding: '5px 20px 20px'
        }
      },
      deliveryLogTableContainer: {
        height: '700px',
        [theme.breakpoints.down('sm')]: {
          height: '790px'
        }
      },
      deliverylogTableBody: {
        '&:hover': {
          cursor: 'pointer'
        }
      },
      deliverylogHeadersOrder: {
        padding: '16px 10px 16px 10px',
        lineHeight: '1.13',
        fontSize: '16px',
        cursor: 'pointer'
      },
      deliverylogHeaders: {
        padding: '16px 10px 16px 10px',
        lineHeight: '1.13',
        fontSize: '16px',
        cursor: 'pointer'
      },
      deliverylogTableRows: {
        padding: '16px 10px 16px 14px',
        height: '70px',
        '&$selected': {
          borderWidth: 0,
          borderLeftWidth: 20,
          borderColor: 'black',
          borderStyle: 'solid',
          backgroundColor: 'white'
        },
        '&$selected:hover': {
          backgroundColor: 'white'
        },
        '&$default': {
          backgroundColor: 'white'
        },
        '&$default:hover': {
          backgroundColor: 'white'
        }
      },
      selected: {},
      default: {},
      drawerContainer: {
        width: '713px',
        background: 'white',
        color: '#2A2A2A',
        [theme.breakpoints.down('sm')]: {
          width: 'auto'
        }
      },
      drawerHeaderContainer: {
        alignItems: 'center',
        justifyContent: 'space-between',
        background: 'transparent',
        padding: '32px 32px 32px 32px',
        [theme.breakpoints.only('xs')]: {
          padding: '32px 10px 32px 10px'
        }
      },
      drawerHeaderText: {
        fontSize: '32px',
        margin: '0px',
        fontWeight: 600,
        [theme.breakpoints.only('xs')]: {
          fontSize: '20px',
          width: '180px',
          whiteSpace: 'normal',
          wordBreak: 'break-all'
        }
      },
      drawerCloseIcon: {
        '& > * > *': {
          [theme.breakpoints.only('xs')]: {
            width: '30px',
            height: '30px'
          }
        }
      },
      orderTimeContainer: {
        background: 'transparent',
        padding: '0px 40px 16px 40px',
        [theme.breakpoints.only('xs')]: {
          padding: '0px 10px 16px 10px'
        }
      },
      orderTimeBlock: {
        background: 'transparent',
        padding: '16px 0px 16px 0px'
      },
      kioskNameBlock: {
        background: 'transparent',
        padding: '16px 0px 8px 0px'
      },
      kioskDetailsHeader: {
        width: '230px',
        [theme.breakpoints.only('xs')]: {
          width: '100px',
          whiteSpace: 'normal',
          wordBreak: 'break-all',
          paddingRight: '10px'
        }
      },
      kioskDetailsContent: {
        [theme.breakpoints.only('xs')]: {
          width: '120px'
        }
      },
      deliveryRefreshEventButton: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'end',
        [theme.breakpoints.only('xs')]: {
          display: 'none'
        }
      },
      filterFormContainer: {
        background: 'transparent',
        padding: '40px 32px 0px 32px',
        display: 'flex',
        [theme.breakpoints.only('xs')]: {
          padding: '30px 20px 0px 20px'
        }
      },
      filterCategoryBox: {
        background: 'transparent',
        height: '100px',
        minWidth: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        [theme.breakpoints.down('xs')]: {
          height: '100px'
        },
        '& > * > *': {
          [theme.breakpoints.down('xs')]: {
            minWidth: '240px',
            width: '245px'
          }
        }
      },
      filterCategoryLabel: {
        padding: '16px 24px',
        margin: '0px 0px 10px',
        fontSize: '16px',
        fontWeight: 'bold'
      },
      filterInputField: {
        width: '350px',
        borderRadius: '15px',
        height: '60px',
        color: 'grey',
        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: '1px !important'
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: color.BLACK
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: color.BLACK
        }
      },
      datePickerContainer: {
        '& .react-datepicker__close-icon': {
          padding: '0 10px 0 0',
          height: '93%'
        },
        '& .react-datepicker__close-icon::after': {
          backgroundColor: '#F46D2E'
        },
        '& .react-datepicker__day--selected': {
          backgroundColor: '#F46D2E',
          color: 'white'
        },
        '& .react-datepicker__day--today': {
          backgroundColor: '#F46D2E',
          color: 'white'
        },
        '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected':
          {
            backgroundColor: '#F46D2E',
            color: 'white'
          },
        '& .react-datepicker__today-button': {
          color: '#F46D2E'
        },
        '& .react-datepicker': {
          left: '-50px'
        }
      },
      datePickerInput: {
        fontSize: '14px',
        backgroundColor: 'white',
        border: 'solid 0.1em #cbd4c9',
        width: '350px',
        height: '60px',
        padding: '12px',
        borderRadius: '15px',
        display: 'flex',
        textAlign: 'center',
        alignItems: 'center'
      },
      datePickerComponent: {
        width: '360px',
        height: '60px',
        borderRadius: '15px',
        padding: '12px'
      },
      '.my-datepicker-wrapper .react-datepicker-wrapper': {
        /* add your custom styles here */
        // border: '1px solid red'
      },
      resetFiltersButton: {
        display: 'flex',
        flexDirection: 'column',
        float: 'right',
        width: '144px',
        marginRight: '32px',
        [theme.breakpoints.only('xs')]: {
          display: 'none'
        }
      },
      applyFiltersButton: {
        display: 'flex',
        flexDirection: 'column',
        float: 'left',
        width: '250px',
        margin: '40px 0px 24px 56px',
        [theme.breakpoints.only('xs')]: {
          display: 'none'
        }
      },
      deliverylogNoDataBox: {
        width: '470px',
        [theme.breakpoints.down('xs')]: {
          width: '200px'
        }
      },
      deliverylogNoDataHeader: {
        textAlign: 'center',
        fontSize: '48px',
        margin: '0px',
        fontWeight: 600,
        [theme.breakpoints.only('sm')]: {
          fontSize: '35px'
        },
        [theme.breakpoints.only('xs')]: {
          fontSize: '25px'
        }
      },
      deliverySkeletonContainer: {
        display: 'flex',
        flex: '0 1 auto',
        flexDirection: 'column',
        background: 'transparent',
        padding: '16px 32px 16px 32px',
        overflow: 'hidden',
        gap: '25px',
        '& > *': {
          [theme.breakpoints.down('sm')]: {
            width: 'auto'
          }
        }
      },
      inputRoot: {
        '& .MuiOutlinedInput-notchedOutline': {
          borderRadius: '30px'
        },
        '& .MuiOutlinedInput-input': {
          padding: '18px 30px'
        },
        '& .MuiInputLabel-outlined': {
          transform: 'translate(14px, 10px) scale(1)'
        },
        '& .MuiInputLabel-shrink': {
          transform: 'translate(14px, -6px) scale(0.75)'
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'grey'
        }
      },
      root: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& .MuiTextField-root': {
          // marginLeft: theme.spacing(2)
        },
        '& .MuiInputLabel-root': {
          position: 'relative',
          left: theme.spacing(-2),
          transform: 'none'
        }
      },
      searchField: {
        marginRight: theme.spacing(1),
        width: '300px'
      },
      buttonStyl: {
        '&.MuiChip-outlined .MuiChip-deleteIcon': {
          color: 'white'
        }
      },
      footer: {
        width: '100%',
        overflow: 'hidden',
        padding: '0px 40px'
      },
      total: {
        float: 'right',
        margin: 0,
        fontSize: '20px',
        padding: '10px',
        fontWeight: 900
      },
      body: {
        overflow: props && props.isOpen ? 'hidden' : 'auto'
      }
    })
  );
